import type { paths } from '@pba/types-openapi-node';
import type { ConfigRequest } from '@pba/utils';
import { type ApiClientResponse, nodeApiClient, nodeApiRoutes } from 'common/services';

export type GetNodeOrganizationsDataObject =
  paths['/organizations']['get']['responses']['default']['content']['application/json'];
export type GetNodeOrganizationsRequest = paths['/organizations']['get']['parameters']['query'];

export const getNodeOrganizations = async ({ config }: ConfigRequest<GetNodeOrganizationsRequest>) =>
  nodeApiClient.get<GetNodeOrganizationsDataObject, ApiClientResponse<GetNodeOrganizationsDataObject>>(
    nodeApiRoutes.organizations.find,
    config,
  );
